import { FileUploadInfo_Handle, FileUploadInfo_Loading, FileUploadInfo_View, IsShowFile_loading } from './action';

const initState = {
    uploadFileLoading: {},
    viewImage: {},
    isShowFileloading: {},
    subQuestionTemplate: {
        "questionId": "",
        "questionLocales": [
            {
                "locale": "cn",
                "detail": "其他文件"
            },
            {
                "locale": "en",
                "detail": "other file"
            }
        ],
        "index": 1,
        "hintLocales": null,
        "answerType": 6,
        "answers": null,
        "questionIndicator": null,
        "userAnswer": {   
            "name": null,
            "documentUploadId": null,
            "iccmFileNetId": null,
            "fileNetId": null,
            "status": null,
            "type": null,
            "indicator": null,
            "docUploadRespDateTime": null,
            "iccmRespDateTime": null
        },
        "displayConditions": null,
        "mandatoryConditions": null,
        "subQuestions": null,
        "canRepeat": true,
        "referTo": null,
        "questionStatus": 0
    }
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case FileUploadInfo_Handle: 
            return {
                ...state,
                ...action.data
            };
        case FileUploadInfo_Loading: 
            return {
                ...state,
                uploadFileLoading: {
                    ...state.uploadFileLoading,
                    ...action.data
                }
            };
        /* istanbul ignore next */
        case FileUploadInfo_View: 
            const questionId = action.questionId;
            const srcTmp = state.viewImage[questionId] ? state.viewImage[questionId].src : null
            if (srcTmp !== action.data[questionId].src) {
                return {
                    ...state,
                    viewImage: {
                        ...state.viewImage,
                        ...action.data
                    }
                };
            } else {
                return state;
            }
        case IsShowFile_loading:
            return {
                ...state,
                isShowFileloading: {
                    ...state.isShowFileloading,
                    ...action.data
                }
            } 
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/state/reducer.js